import { strapiClient } from "@shared/api";
import rebuild from "@shared/api/rebuild";

import type { DialogueResponse } from "../model/types";

export const getCurrentDialogue = async (dialogueId: string) => {
  const answers = strapiClient.collection("dialogues");

  const res = await answers.find({
    filters: {
      dialogue_id: {
        $eq: dialogueId,
      },
    },
    populate: "*",
  });

  //   const res = await answers.findOne(dialogueId, {
  //     populate: "*",
  //   });

  if (!res?.data) {
    throw new Error(`Share with ID ${dialogueId} not found`);
  }

  return rebuild(res.data[0]) as DialogueResponse;
};
